export class FeedbackNotFoundError extends Error {}
